// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"387":"66c7fa8a","652":"9f450abf","682":"4e30b7d9","778":"4687a3f5"}[chunkId] + ".chunk.css";
};